import { add, isAfter, set } from "date-fns";
import { z, date, object, string } from "zod";

export const CreatePhoneCallFormSchema = object({
  date: date().refine(
    (date) =>
      isAfter(
        date,
        add(
          set(new Date(), {
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0,
          }),
          { days: 1 },
        ),
      ),
    {
      message: "Date must be at least 24 hours in the future",
    },
  ),
  time: date(),
  phone: string()
    .min(
      1,
      "You must specify you phone number in order to make a phone call reservation.",
    )
    .max(255, "Phone number is too long"),
}).superRefine(({ date, time }, { addIssue }) => {
  const combinedDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    time.getHours(),
    time.getMinutes(),
  );

  const isAfter24Hours = isAfter(combinedDate, add(new Date(), { hours: 24 }));

  if (!isAfter24Hours) {
    addIssue({
      path: ["time"],
      code: "custom",
      message: "The reservation is placed at least 24 hours prior to the call.",
    });
  }
  return isAfter24Hours;
});

export type CreatePhoneCallFormSchema = z.infer<
  typeof CreatePhoneCallFormSchema
>;
